@if (cards.length > 0) {
  <div class="bg-white rounded-3xl shadow-sm p-4">
    <div class="flex items-baseline justify-between mb-3">
      <h3 class="text-base font-semibold text-[#023E42]">{{ 'home.garden-today.advices-title' | translate }}</h3>
      <span class="text-[10px] text-[#9BA5A1]">{{ 'home.garden-today.advices-subtitle' | translate }}</span>
    </div>

    <div class="flex flex-col gap-2">
      @for (card of cards; track card.plantUid + card.trigger) {
        <div class="bg-[#FBFDFC] border border-[#E6EEE9] rounded-2xl p-3 flex gap-3">
          @if (card.imageUrl) {
            <img [src]="card.imageUrl" [alt]="card.plantName"
              class="w-12 h-12 rounded-xl object-cover shrink-0">
          } @else {
            <div class="w-12 h-12 rounded-xl flex items-center justify-center text-xl shrink-0"
              [style.background-color]="chipStyle(card.trigger).background">
              {{ chipStyle(card.trigger).emoji }}
            </div>
          }
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1.5 mb-1 flex-wrap">
              <span class="text-[13px] font-semibold text-[#023E42] truncate">{{ card.plantName }}</span>
              @if (card.stepName) {
                <span class="text-[10px] text-grey-600 bg-grey-100 rounded-full px-2 py-0.5 shrink-0">{{ card.stepName }}</span>
              }
              <span class="inline-flex items-center gap-1 text-[10px] font-bold rounded-full px-2 py-0.5 ml-auto shrink-0"
                [style.background-color]="chipStyle(card.trigger).background"
                [style.color]="chipStyle(card.trigger).ink">
                {{ chipStyle(card.trigger).emoji }} {{ 'home.garden-today.tags.' + card.trigger | translate }}
              </span>
            </div>
            <p class="text-xs text-[#3c4a45] leading-relaxed">{{ card.text }}</p>
          </div>
        </div>
      }
    </div>

    <button type="button" (click)="askWilly()"
      class="w-full mt-3 flex items-center justify-center gap-2 bg-[#DAF2E0] active:bg-[#C3E5CE] transition-colors rounded-2xl py-2.5">
      <img src="/assets/images/willy/willy_hi.png" alt="Willy" class="w-7 h-7 object-contain">
      <span class="text-[13px] font-semibold text-[#023E42]">{{ 'home.garden-today.ask-willy' | translate }}</span>
    </button>
  </div>
}
